module.exports = [
  {
    key: 'fullname',
    label: { es: 'Nombre y appellidos' },
    type: 'string',
    required: true,
    value: null,
  },
  {
    key: 'email',
    label: { es: 'Email' },
    type: 'string',
    required: true,
    value: null,
  },
  {
    key: 'phone',
    label: { es: 'Teléfono' },
    type: 'string',
    required: true,
    value: null,
  },
  {
    key: 'room',
    label: { es: 'Habitación' },
    type: 'string',
    required: true,
    value: null,
  },
  {
    key: 'activity',
    label: { es: 'Actividad' },
    type: 'select',
    required: true,
    items: [
      { id: '1', name: { es: '1', en: '11' } },
      { id: '2', name: { es: '2', en: '22' } },
    ],
    value: null,
  },
  {
    key: 'date',
    label: { es: 'Fecha' },
    type: 'date',
    required: true,
    value: null,
  },
  {
    key: 'time',
    label: { es: 'Horario' },
    type: 'select',
    required: false,
    items: [
      { id: null, name: { es: 'Sin preferencia' } },
      { id: 'mañana', name: { es: 'Mañana' } },
      { id: 'tarde', name: { es: 'Tarde' } },
      { id: 'noche', name: { es: 'Noche' } },
    ],
    value: null,
  },
  {
    key: 'adults',
    label: { es: 'Nº adultos' },
    type: 'select',
    required: false,
    items: [
      { id: '1', name: { es: '1' } },
      { id: '2', name: { es: '2' } },
      { id: '3', name: { es: '3' } },
      { id: '4', name: { es: '4' } },
      { id: '5', name: { es: '5' } },
    ],
    value: '1',
  },
  {
    key: 'childrens',
    label: { es: 'Nº niños' },
    type: 'select',
    required: false,
    items: [
      { id: '0', name: { es: '0' } },
      { id: '1', name: { es: '1' } },
      { id: '2', name: { es: '2' } },
      { id: '3', name: { es: '3' } },
      { id: '4', name: { es: '4' } },
    ],
    value: '0',
  },
  {
    key: 'privateOrGroup',
    label: { es: 'Privado o grupo' },
    type: 'select',
    required: false,
    items: [
      { id: null, name: { es: 'Indiferente' } },
      { id: 'private', name: { es: 'En privado' } },
      { id: 'group', name: { es: 'En grupo' } },
    ],
    value: null,
  },
  {
    key: 'othersActivities',
    label: { es: 'Otras actividades' },
    type: 'string',
    required: false,
    value: null,
  },
]
